/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  

    
 // document.addEventListener("DOMContentLoaded", function() {
   //  const swatches = document.querySelectorAll(".swatches.swatch__button.swatch__button--square");
   // var replace;
   //  swatches.forEach(function(swatch) {
   //      swatch.addEventListener("mouseenter", function() {
   //        // swatch.classList.add();
   //          const img = swatch.querySelector("img");
   //          if (img) {
   //              const imgSrc = img.getAttribute("src");

   //                    console.log(imgSrc);
   //              let gridItem = swatch.closest(".grid-item");
                
   //              while (!gridItem && swatch.parentNode) {
   //                  swatch = swatch.parentNode;
   //                  if (swatch.classList && swatch.classList.contains('grid-item')) {
   //                      gridItem = swatch;
   //                  }
   //              }

   //              if (gridItem) {
   //                  const targetImg = gridItem.querySelector(".image-wrapper img");
   //                  if (targetImg) {
   //                     replace =targetImg.getAttribute("src");
   //                      targetImg.setAttribute("src", imgSrc);
   //                      targetImg.setAttribute("srcset", imgSrc);
   //                  }
   //              } else {
   //                  console.log("No .grid-item parent found.");
   //              }
   //          }
   //      });
      // swatch.addEventListener("mouseleave", function() {
      //           let gridItem = swatch.closest(".grid-item");
      //           if (gridItem) {
      //               const targetImg = gridItem.querySelector(".image-wrapper img");
      //               if (targetImg) {
      //                   targetImg.setAttribute("src", replace);
      //                   targetImg.setAttribute("srcset", replace);
      //               }
      //           } else {
      //               console.log("No .grid-item parent found.");
      //           }
      // });
    // });

  
// });




  document.addEventListener("DOMContentLoaded", function() {
    let replace;

    // Use event delegation to handle dynamic content
    document.addEventListener("mouseenter", function(event) {
        let swatch = event.target.closest(".swatches.swatch__button.swatch__button--square");

        if (swatch) {
            const img = swatch.querySelector("img");
            if (img) {
                const imgSrc = img.getAttribute("src");
                // console.log(imgSrc);

                let gridItem = swatch.closest(".grid-item");

                // Ensure the loop to manually find gridItem works correctly
                while (!gridItem && swatch.parentNode) {
                    swatch = swatch.parentNode;
                    if (swatch.classList && swatch.classList.contains('grid-item')) {
                        gridItem = swatch;
                    }
                }

                if (gridItem) {
                    const targetImg = gridItem.querySelector(".image-wrapper img");
                    if (!imgSrc.includes("gif")) {
                        replace = targetImg.getAttribute("src");
                        targetImg.setAttribute("src", imgSrc);
                        targetImg.setAttribute("srcset", imgSrc);
                    }
                  else{
                      console.log("yessssss");
                  }
                } else {
                    console.log("No .grid-item parent found.");
                }
            }
        }
    }, true);  // Use capture phase for better delegation
});



  



  // PDP: Gallery filter + dynamic title on color swatch change
  document.addEventListener('DOMContentLoaded', function() {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

    var slides = Array.from(document.querySelectorAll('.product__slide'));
    if (slides.length === 0) return;

    // Build a map: imageId -> color, using featured_media per color
    // Then assign each slide a color bracket by position
    var colorByImageId = {};
    var colorBrackets = []; // [{color, startIndex}] sorted by slide position

    product.variants.forEach(function(v) {
      if (v.featured_media && !colorByImageId[v.featured_media.id]) {
        colorByImageId[v.featured_media.id] = v.option1;
      }
    });

    // Find which slide index each color's featured image sits at
    slides.forEach(function(slide, i) {
      var id = parseInt(slide.getAttribute('data-image-id'), 10);
      if (colorByImageId[id]) {
        colorBrackets.push({ color: colorByImageId[id], startIndex: i });
      }
    });

    // Sort brackets by position ascending
    colorBrackets.sort(function(a, b) { return a.startIndex - b.startIndex; });

    // Assign each slide to a color based on which bracket it falls into
    function getColorForSlide(index) {
      var assigned = null;
      for (var i = 0; i < colorBrackets.length; i++) {
        if (index >= colorBrackets[i].startIndex) {
          assigned = colorBrackets[i].color;
        } else {
          break;
        }
      }
      return assigned;
    }

    function applyColorFilter(color) {
      // Gallery filter
      if (colorBrackets.length > 1) {
        slides.forEach(function(slide, i) {
          var slideColor = getColorForSlide(i);
          slide.style.display = (slideColor === color) ? '' : 'none';
        });
      }

      // Dynamic title
      var titleEl = document.querySelector('[data-product-title]');
      if (titleEl && color) {
        var baseTitle = titleEl.getAttribute('data-base-title') || titleEl.textContent.trim();
        titleEl.textContent = baseTitle + ' - ' + color;
      }
    }

    // Run on swatch click
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail && event.detail.variant;
      if (variant) applyColorFilter(variant.option1);
    });

    // Run on page load — use ?variant= if present, else read checked color radio
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    var initialColor = null;

    if (variantId) {
      var variant = product.variants.find(function(v) { return String(v.id) === variantId; });
      if (variant) initialColor = variant.option1;
    }

    if (!initialColor) {
      var checkedColor = document.querySelector('input[data-index="option1"]:checked');
      if (checkedColor) initialColor = checkedColor.value;
    }

    if (initialColor) applyColorFilter(initialColor);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function() {
  function processElement() {
    var pElement = document.querySelector('ul.easytabs-tabs li:first-child span');
    
    if (pElement) {
      var gettext = pElement.textContent.trim(); // Use trim() to remove any leading/trailing whitespace
      pElement.remove();
      
      setTimeout(function() {
        var newH5 = document.createElement('span');
        newH5.textContent = 'DESCRIPTION'; // Set the text content to 'DESCRIPTION'
        
        var pElementParent = document.querySelector('ul.easytabs-tabs li:first-child');
        if (pElementParent) {
          pElementParent.appendChild(newH5);
        }
      }, 1000);
    }
  }
  
  processElement(); // Call the function to execute the changes
});


document.addEventListener('DOMContentLoaded', function() {
    var items = document.querySelectorAll('.easytabs-content-item');
    items.forEach(function(item) {
        var holder = item.querySelector('.easytabs-content-holder');
        if (holder) {
            var content = holder.innerHTML; //f   Use innerHTML to modify content
            var newContent = content.replace(/DESCRIPTION/g, '<span style="display:none;">DESCRIPTION</span>');
            holder.innerHTML = newContent;
        }
    });
});
